import styles from "./CheckReminder.module.css";
import { ReactComponent as WarningIcon } from "../../../assets/icons/ic-warning.svg";

function BuyLoadCheckReminder(props: any) {
	const { selectedPartners, partnerDetails, ...others } = props;
	const availableSpiel = "To be available soon.";

	return (
		<div className={styles.reminderWrapper}>
			<div className={styles.icon}>
				<WarningIcon />
			</div>
			<div className={styles.textContainer}>
				<div>
					Please ensure to input the correct payee name to avoid
					cancellation of checks and possible penalties.
				</div>
				<div style={{ marginTop: "18px" }}>
					<b>{selectedPartners[0].description}</b> Check Payment
					Details
					<div>
						<table>
							<tbody>
								<tr>
									<td style={{ width: "15%" }}>
										<b>Bank</b>
									</td>
									<td>:</td>
									<td>
										{partnerDetails.bank_name ? (
											partnerDetails.bank_name
										) : (
											<b>{availableSpiel}</b>
										)}
									</td>
								</tr>
								<tr>
									<td>
										<b>Accepted Payee Name</b>
									</td>
									<td>:</td>
									<td>
										{partnerDetails.payee_names ? (
											partnerDetails.payee_names
										) : (
											<b>{availableSpiel}</b>
										)}
									</td>
								</tr>
								<tr>
									<td>
										<b>Account No</b>
									</td>
									<td>:</td>
									<td>
										{partnerDetails.account_no ? (
											partnerDetails.account_no
										) : (
											<b>{availableSpiel}</b>
										)}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	);
}

export default BuyLoadCheckReminder;
